package com.dotdrives.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class Note(
    val id: String,
    @SerialName("org_id")
    val orgId: String,
    @SerialName("giver_id")
    val giverId: String,
    val title: String,
    val body: String,
    @SerialName("created_by")
    val createdBy: String,
    @SerialName("created_at")
    val createdAt: Instant,
)
